import React from 'react'
import { createPortal } from 'react-dom'
import FormattedMessage from '../../helpers/FormattedMessage'
import { useBodyScroll } from '../../helpers/useBodyScroll'

import styles from './Prompt.module.scss'

interface IProps {
  title?: string
  componentTitle?: React.ReactNode
  text?: string
  componentText?: React.ReactNode
  cancel: () => void
  submit: () => void
  submitText: string
  warning?: boolean
}

export const Prompt = ({
  cancel,
  submit,
  submitText,
  title,
  componentTitle,
  text,
  componentText,
  warning,
}: IProps) => {
  useBodyScroll(false)

  return createPortal(
      <div className={styles.PromptWrapper}>
        <div className={styles.Overlay} />
        <div className={styles.Container}>
          {title &&
            <h3 className={styles.Title}>
              <FormattedMessage id={title} />
            </h3>
          }
          {componentTitle &&
            <h3 className={styles.Title}>
              {componentTitle}
            </h3>
          }
          {text &&
          <h3 className={styles.Text}>
              <FormattedMessage id={text} />
          </h3>
          }
          {componentText &&
            <h3 className={styles.Text}>
              {componentText}
            </h3>
          }
          <div className={styles.ButtonsWrapper}>
            <button className={styles.Cancel} onClick={cancel}>
              <FormattedMessage id={'cancel'} />
            </button>
            <button className={`${styles.Submit} ${warning && styles.Warning}`} onClick={submit}>
              <FormattedMessage id={submitText} />
            </button>
          </div>
        </div>
      </div>,
    document.body
  )
}
